import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import authService from './auth.service';
import { toast } from 'react-toastify';

const initialState = {
  user: null,
  loading: false,
  error: null,
  loggedIn: false,
  isRegistered: false,
  email: '',
  emailSent: false,
  emailVerified: false,
  passwordReset: false,
};

export const login = createAsyncThunk(
  'auth/login',
  async (payload, thunkAPI) => {
    try {
      const res = await authService.login(payload);
      console.log('login', res);
      if (res.data.msg === 'not found') {
        toast.error('User not found');
        return res.data.msg;
      } else {
        let x = JSON.stringify({
          user: res.data.data,
          token: res.data.access_token,
        });
        localStorage.setItem('postager_auth', x);
        return res.data.data;
      }
    } catch (err) {
      toast.error('something went wrong');
      return thunkAPI.rejectWithValue({ error: err });
    }
  }
);

export const register = createAsyncThunk(
  'auth/register',
  async (payload, thunkAPI) => {
    try {
      const res = await authService.register(payload);
      if (res.data.msg === 'User Created') {
        toast.success('Registration Successful');
        return 1;
      } else if (res.data.msg === 'User Already Exist') {
        toast.error('User Already Exists');
        return 0;
      }
      return res.data.msg;
    } catch (err) {
      console.error(err);
      return thunkAPI.rejectWithValue({ error: err });
    }
  }
);

export const forgotPassword = createAsyncThunk(
  'auth/forgotPassword',
  async (payload, thunkAPI) => {
    try {
      const res = await authService.forgotPassword(payload);
      if (res.data.status === 1) {
        toast.success('Email sent succesfully!');
        return 1;
      } else if (res.data.code === 0) {
        toast.error('Email is not registerd with us!');
        return 0;
      }

      return res.data.msg;
    } catch (err) {
      console.error(err);
      return thunkAPI.rejectWithValue({ error: err });
    }
  }
);

export const verifyCode = createAsyncThunk(
  'auth/verifyCode',
  async (payload, thunkAPI) => {
    try {
      const res = await authService.verifyCode(payload);

      if (res.data.status === 1) {
        toast.success(res.data.msg);
        return 1;
      } else if (res.data.status === 0) {
        toast.error(res.data.msg);
      }
      return res.data.msg;
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
      return thunkAPI.rejectWithValue({ error: err });
    }
  }
);

export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async (payload, thunkAPI) => {
    try {
      const res = await authService.resetPassword(payload);

      if (res.data.status === 1) {
        toast.success(res.data.msg);
        return 1;
      } else if (res.data.status === 0) {
        toast.error(res.data.msg);
      }
      return res.data.msg;
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
      return thunkAPI.rejectWithValue({ error: err });
    }
  }
);
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserLoggedIn: (state) => {
      let postager_auth = localStorage.getItem('postager_auth');
      postager_auth = JSON.parse(postager_auth);
      if (postager_auth?.token?.length > 0) {
        state.user = postager_auth.user;
        state.loading = false;
        state.error = null;
        state.loggedIn = true;
      } else {
        state.user = null;
        state.loading = false;
        state.error = 'user not found';
        state.loggedIn = false;
      }
    },
    logout: () => {
      localStorage.removeItem('postager_auth');
      window.location.reload();
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
  },
  extraReducers: {
    [login.pending]: (state) => {
      state.loading = true;
    },
    [login.fulfilled]: (state, action) => {
      state.loading = false;
      state.user = action.payload;
      state.loggedIn = true;
    },
    [login.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [register.pending]: (state) => {
      state.loading = true;
    },
    [register.fulfilled]: (state, action) => {
      state.loading = false;
      if (action.payload === 1) {
        state.isRegistered = true;
      } else {
        state.isRegistered = false;
      }
    },
    [register.rejected]: (state, action) => {
      state.loading = false;
      state.isRegistered = false;
      state.error = action.payload;
    },
    [forgotPassword.pending]: (state) => {
      state.loading = true;
    },
    [forgotPassword.fulfilled]: (state, action) => {
      state.loading = false;
      if (action.payload === 1) {
        state.emailSent = true;
      } else {
        state.emailSent = false;
      }
    },
    [forgotPassword.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [verifyCode.pending]: (state) => {
      state.loading = true;
    },
    [verifyCode.fulfilled]: (state, action) => {
      state.loading = false;
      if (action.payload === 1) {
        state.emailVerified = true;
      } else {
        state.emailVerified = false;
      }
    },
    [verifyCode.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [resetPassword.pending]: (state) => {
      state.loading = true;
    },
    [resetPassword.fulfilled]: (state, action) => {
      state.loading = false;
      if (action.payload === 1) {
        state.passwordReset = true;
      } else {
        state.passwordReset = false;
      }
    },
    [resetPassword.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});
export const { setUserLoggedIn, logout, setEmail } = authSlice.actions;
export default authSlice.reducer;
